var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.computedDimensions)},[(_vm.white)?_c('use',{attrs:{"xlink:href":"#icon-spinner-white"}}):_c('use',{attrs:{"xlink:href":"#icon-spinner"}})])}
var staticRenderFns = []

export { render, staticRenderFns }